import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StreamIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stream"}/>
}
